import { create } from "zustand";
import { ProductsAPI } from "../Helpers/ConfigProvider";

const usePopupStore = create((set, get) => ({
  popups: [],
  loading: false,
  errors: [],
  getPopups: async () => {
    if (get().loading) {
      return;
    }
    set({ loading: true, errors: [] });
    try {
      const response = await fetch(`${ProductsAPI}/Popups`);

      const data = await response.json();
      if (!response.ok) {
        set((state) => ({ errors: [...state.errors, data], loading: false }));
        return;
      }
      set({ popups: data, loading: false });
    } catch (error) {
      set((state) => ({ errors: [...state.errors, error], loading: false }));
    } finally {
      set({ loading: false });
    }
  },
}));

export default usePopupStore;
